import React from "react";


function MobileAdvantage({ selectProduct }) {
  const advantages =
    selectProduct && selectProduct[0] && selectProduct[0]?.Advantages;

  return (
    <div className="w-full px-4 py-3 bg-white-1">
      {advantages && Object.keys(advantages).length > 0 && (
        <div className="flex flex-col items-start font-medium">
          {/* 🔹 Title */}
          <h3 className="text-gray-900 mb-3 text-lg font-bold tracking-wide">
            Advantages
          </h3>

          {/* 🔹 Advantages Grid */}
          <div className="grid grid-cols-4 gap-3 w-full justify-items-center items-start">
            {advantages?.Advantage1 && (
              <AdvantageItem
                image={advantages?.Image1}
                text={advantages?.Advantage1}
              />
            )}
            {advantages?.Advantage2 && (
              <AdvantageItem
                image={advantages?.Image2}
                text={advantages?.Advantage2}
              />
            )}
            {advantages?.Advantage3 && (
              <AdvantageItem
                image={advantages?.Image3}
                text={advantages?.Advantage3}
              />
            )}
            {advantages?.Advantage4 && (
              <AdvantageItem
                image={advantages?.Image4}
                text={advantages?.Advantage4}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const AdvantageItem = ({ image, text }) => (
  <div className="flex flex-col items-center text-center">
    <img
      loading="lazy"
      src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_ADVANTAGE/${image}`}
      alt={text}
      className="w-[45px] h-[45px] rounded-full border border-gray-200 mb-1 object-contain"
    />
    <span className="text-[0.75rem] text-gray-800 leading-snug max-w-[60px]">
      {text}
    </span>
  </div>
);

export default MobileAdvantage;
